<footer class="home-footer" role="contentinfo">
  <div class="home-footer__inner">
    <div class="home-footer__top">
      <div class="home-footer__brand">
        <img class="home-footer__logo" src="assets/img/Home/svg/Logo_neocredito_footer.svg" alt="neocrédito" width="284"
          height="95" />
        <p class="home-footer__claim">
          Impulsamos el <strong>negocio</strong><br />
          que <span class="home-footer__claim-accent">quieres ser</span>
        </p>
      </div>

      <ul class="home-footer__social" aria-label="Redes sociales">
        <li>
          <a class="home-footer__social-link" href="https://twitter.com/bancoldex" target="_blank"
            rel="noopener noreferrer" aria-label="X (Twitter)">
            <img class="home-footer__social-img" src="assets/img/Home/footer/Ico_twitter.svg" alt="" width="24"
              height="24" />
          </a>
        </li>
        <li>
          <a class="home-footer__social-link" href="https://www.instagram.com/bancoldex" target="_blank"
            rel="noopener noreferrer" aria-label="Instagram">
            <img class="home-footer__social-img" src="assets/img/Home/footer/Ico_instagram.svg" alt="" width="24"
              height="24" />
          </a>
        </li>
        <li>
          <a class="home-footer__social-link" href="https://www.linkedin.com/company/grupo-bancoldex" target="_blank"
            rel="noopener noreferrer" aria-label="LinkedIn">
            <img class="home-footer__social-img" src="assets/img/Home/footer/Ico_linkedin.svg" alt="" width="24"
              height="24" />
          </a>
        </li>
        <li>
          <a class="home-footer__social-link" href="https://www.facebook.com/bancoldex" target="_blank"
            rel="noopener noreferrer" aria-label="Facebook">
            <img class="home-footer__social-img" src="assets/img/Home/footer/Ico_facebook.svg" alt="" width="24"
              height="24" />
          </a>
        </li>
      </ul>
    </div>

    <div class="home-footer__middle">
      <p class="home-footer__description">
        El punto de encuentro entre dueños de negocio y las mejores entidades financieras de
        Colombia. Respaldados por Bancóldex.
      </p>

      <nav class="home-footer__links" aria-label="Links de interés">
        <h3 class="home-footer__links-title">Links de interés</h3>
        <ul class="home-footer__links-list">
          <li>
            <a class="home-footer__link"
              href="https://www.bancoldex.com/es/contactanos/defensor-del-consumidor-financiero-3740" target="_blank"
              rel="noopener noreferrer">
              Defensor del consumidor financiero
            </a>
          </li>
          <li>
            <button type="button" class="home-footer__link home-footer__link--button"
              (click)="openInfoModal('contacto')">
              Información de contacto
            </button>
          </li>
          <li>
            <button type="button" class="home-footer__link home-footer__link--button"
              (click)="openInfoModal('atencion')">
              Línea de atención
            </button>
          </li>
          <li>
            <a class="home-footer__link" href="preguntas-frecuentes" target="_blank" rel="noopener noreferrer">
              Preguntas frecuentes
            </a>
          </li>
        </ul>
      </nav>
    </div>

    @if (logos.length) {
      <div class="home-footer__logos" aria-label="Logos institucionales">
        @for (logo of logos; track logo.imagen) {
          @if (logo.url) {
            <a class="home-footer__logo-inst" [href]="logo.url" target="_blank" rel="noopener noreferrer"
              [attr.aria-label]="logo.alt">
              <img [src]="logo.imagen" [alt]="logo.alt" height="48" />
            </a>
          } @else {
            <span class="home-footer__logo-inst" [attr.aria-label]="logo.alt">
              <img [src]="logo.imagen" [alt]="logo.alt" height="48" />
            </span>
          }
        }
      </div>
    }

    <div class="home-footer__bottom">
      <hr class="home-footer__divider" />
      <p class="home-footer__copyright">
        Copyright © Todos los derechos reservados a
        <a class="home-footer__copyright-link" href="https://www.bancoldex.com/" target="_blank"
          rel="noopener noreferrer">
          Bancóldex
        </a>
        - desarrollado por
        <a class="home-footer__copyright-link" href="https://www.smartsoft.la/" target="_blank"
          rel="noopener noreferrer">
          SmartSoft
        </a>
      </p>
    </div>
  </div>
</footer>

@if (modalOpen && modalKind) {
  <dialog class="home-footer-modal" open aria-labelledby="home-footer-modal-title">
    <button type="button" class="home-footer-modal__backdrop" aria-label="Cerrar" (click)="closeInfoModal()"></button>
    <div class="home-footer-modal__dialog">
      <div class="home-footer-modal__header">
        <h5 class="home-footer-modal__title" id="home-footer-modal-title">{{ modalTitle }}</h5>
        <button type="button" class="home-footer-modal__close" aria-label="Cerrar"
          (click)="closeInfoModal()">&times;</button>
      </div>
      <div class="home-footer-modal__body">
        <app-contacto-atencion-info
          [kind]="modalKind"
          variant="modal"
          [showTitle]="false"
        ></app-contacto-atencion-info>
      </div>
      <div class="home-footer-modal__footer">
        <button type="button" class="home-footer-modal__action" (click)="closeInfoModal()">Salir</button>
      </div>
    </div>
  </dialog>
}
